import apiClient from './api';

export interface Blog {
    _id: string;
    image?: string;
    category: string;
    title: string;
    description: string;
    author?: string;
    readTime?: string;
    content: string;
    slug: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface CreateBlogData {
    image?: string;
    category: string;
    title: string;
    description: string;
    author?: string;
    readTime?: string;
    content: string;
    slug: string;
}

export interface UpdateBlogData {
    image?: string;
    category?: string;
    title?: string;
    description?: string;
    author?: string;
    readTime?: string;
    content?: string;
    slug?: string;
}

export interface UploadImageResponse {
    s3Key: string;
    presignedUrl: string;
    expiresIn: number;
    size: number;
    mimetype: string;
    type: string;
}

export interface BlogsListResponse {
    data: Blog[];
    total: number;
    page: number;
    limit: number;
}

class BlogsApi {
    // Upload blog image
    async uploadImage(file: File): Promise<{ s3Key: string; presignedUrl: string }> {
        const formData = new FormData();
        formData.append('image', file);

        const response = await apiClient.postFormData<UploadImageResponse>(
            '/projects-service/api/v1/vulnerabilities/upload/image?type=blog',
            formData,
            {},
            'PROJECTS'
        );

        console.log(response)

        return {
            s3Key: response?.data?.s3Key || '',
            presignedUrl: response?.data?.presignedUrl || '',
        };
    }

    // Get all blogs with pagination
    async getBlogs(page: number = 1, limit: number = 10): Promise<BlogsListResponse> {
        const response = await apiClient.get<BlogsListResponse>(
            `/projects-service/api/v1/content/blog/list?page=${page}&limit=${limit}&featured=false`,
            {},
            'PROJECTS'
        );
        return response.data!;
    }

    // Get blog by ID
    async getById(id: string): Promise<Blog> {
        const response = await apiClient.get<Blog>(
            `/projects-service/api/v1/content/blog/${id}`,
            {},
            'PROJECTS'
        );
        return response.data!;
    }

    // Get blog by slug
    async getBySlug(slug: string): Promise<Blog> {
        const response = await apiClient.get<Blog>(
            `/projects-service/api/v1/content/blog/slug/${slug}`,
            {},
            'PROJECTS'
        );
        return response.data!;
    }

    // Create blog
    async create(data: CreateBlogData): Promise<Blog> {
        const response = await apiClient.post<Blog>(
            '/projects-service/api/v1/content/blog',
            data,
            {},
            'PROJECTS'
        );
        return response.data!;
    }

    // Update blog
    async update(id: string, data: UpdateBlogData): Promise<Blog> {
        const response = await apiClient.patch<Blog>(
            `/projects-service/api/v1/content/blog/${id}`,
            data,
            {},
            'PROJECTS'
        );
        return response.data!;
    }

    // Delete blog
    async delete(id: string): Promise<void> {
        await apiClient.delete(
            `/projects-service/api/v1/content/blog/${id}`,
            {},
            'PROJECTS'
        );
    }
}

export const blogsApi = new BlogsApi();
export default blogsApi;
